const data = [
  // { name: 'Meu Perfil', icon: 'mdi-account-edit-outline', route: '/profile' },
  { name: 'Sair', icon: 'mdi-logout', event: 'logout' }
]

export default [...data]
